// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__g2Fhi","title":"Images90_title__1vvCG","images":"Images90_images__2HM4b"};